import React from 'react';
import styled from 'styled-components';
import { DropdownPortal } from '../widgets/dropdownPortal';
import { OptionsPanelContent } from './OptionsPanelContent';
import type { PanelDataState, ImageUrlByPresetType, PresetType } from './useAIProductStagingData';

interface OptionsPanelDesktopProps {
	activePanel: string | null;
	triggerElement: HTMLElement | null;
	onClose: () => void;
	menuId: string;
	options: {
		background?: PanelDataState;
		surface?: PanelDataState;
		mood?: PanelDataState;
		effect?: PanelDataState;
		person?: PanelDataState;
		pose?: PanelDataState;
	};
	isLoading?: boolean;
	selectedValues: {
		background?: number | null;
		surface?: number | null;
		mood?: number | null;
		effect?: number | null;
		person?: number | null;
		pose?: number | null;
	};
	onSelect: (type: PresetType, value: number | null) => void;
	imageUrl?: ImageUrlByPresetType;
	setImageUrl?: React.Dispatch<React.SetStateAction<ImageUrlByPresetType>>;
	handleUpload?: (presetType: PresetType) => void;
	supportsUpload?: boolean;
	required?: boolean;
	allowCustomBackground?: boolean;
	modalType?: 'product-staging' | 'virtual-tryon';
	onWebcamOpen?: () => void;
}

export const OptionsPanelDesktop: React.FC<OptionsPanelDesktopProps> = ({
	activePanel,
	triggerElement,
	onClose,
	options,
	isLoading = false,
	selectedValues,
	onSelect,
	imageUrl,
	setImageUrl,
	handleUpload,
	supportsUpload,
	required = false,
	allowCustomBackground = true,
	modalType = 'product-staging',
	menuId,
	onWebcamOpen,
}) => {
	if (!activePanel || !triggerElement) return null;

	return (
		<DropdownPortal el={triggerElement} anchor={'top'} alignment={'left'} transparentBg={false} onClose={onClose}>
			<DropdownContainer>
				<OptionsPanelContent
					activePanel={activePanel}
					options={options}
					isLoading={isLoading}
					selectedValues={selectedValues}
					onSelect={onSelect}
					imageUrl={imageUrl}
					setImageUrl={setImageUrl}
					handleUpload={handleUpload}
					supportsUpload={supportsUpload}
					required={required}
					allowCustomBackground={allowCustomBackground}
					modalType={modalType}
					menuId={menuId}
					onWebcamOpen={onWebcamOpen}
				/>
			</DropdownContainer>
		</DropdownPortal>
	);
};

const DropdownContainer = styled.div`
	padding: 0.75rem 1rem;
	max-width: 100%;
	width: 400px;
	background-color: white;
	border-radius: 0.75rem;
	box-shadow: 0 10px 40px rgba(0, 0, 0, 0.15);
`;
